import "./PulmonaryCare.module.css";
import Header from "@/reusable_sections/Header";
import ExpertLungHealthManagement from "./sections/ExpertLungHealthManagement";
import ConditionsWeTreat from "./sections/ConditionsWeTreat";
import Footer from "@/reusable_sections/Footer";
export default function PulmonaryCarePage() {
  return <div>
      <Header />
      <ExpertLungHealthManagement />
      <ConditionsWeTreat />
      <Footer />
    </div>;
}